import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { fetch } from '../../service_broker/fetch';
import { ACTION_OPEN_BULK_ACTION } from '../../store/state/actions';
import { resolveRestApi } from '../../router/app-router';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { processHeaders } from '../../store/state/epics/util';
import type { Action } from '../../store/state/state-manager';

export const executeOpenBulkActionRequest = (actionInPayload: Action['payload']) => {
  const { actionID, context, openActionType, caseTypeID, bulkContextID = '', bulkContextType = '' } = actionInPayload;
  const routeKey = ACTION_OPEN_BULK_ACTION;
  const { reqType, restApi } = resolveRestApi(routeKey, {
    caseTypeID,
    actionID,
    bulkContextID,
    bulkContextType
  });

  return from(
    fetch(
      restApi,
      {
        method: reqType
      },
      context
    )
  ).pipe(
    map((response) => {
      return {
        response: response.data,
        actionInPayload,
        headers: processHeaders(response.headers)
      };
    }),
    logAndCatchError(`: Error occurred during ajax call at ${openActionType} Epic : `, context)
  );
};

export default {
  executeOpenBulkActionRequest
};
